/**
 * O aviso de que há veículo fora de todo contrato — e quais são.
 *
 * **O problema não é editar um veículo que já se escolheu; é descobrir qual
 * está errado.** São 1.202 veículos e 104 sem categoria: a ficha resolve o
 * conserto, mas não a procura. Por isso o número fica no topo da lista, e abre
 * na lista dos culpados em vez de mandar procurar.
 *
 * **Ordenado pelo estrago, não por nome.** Quem tem conteúdo publicado vem
 * primeiro, e entre esses quem tem mais linhas de busca presas. Os 74 sem
 * conteúdo são cadastro incompleto — errado, mas ninguém está batendo na porta.
 *
 * **Some sozinho.** Se um dia ninguém estiver sem categoria, não há aviso: o
 * componente não desenha nada. É a diferença entre um alarme e um enfeite.
 */

import { useState } from "react"
import { usarVeiculosSemCategoria } from "@/api/alcanceDoVeiculo"

export function VeiculosSemCategoria({ aoEscolher }: {
  /** Abre a ficha do veículo, onde as categorias são marcadas. */
  aoEscolher: (id: number) => void
}) {
  const { data } = usarVeiculosSemCategoria()
  const [aberto, setAberto] = useState(false)

  if (!data || data.total === 0) return null

  const doem = data.veiculos.filter((v) => v.linhas > 0)
  const resto = data.veiculos.length - doem.length

  return (
    <div style={{
      padding: "8px 14px", borderBottom: "1px solid var(--line2)",
      background: data.comConteudo > 0
        ? "color-mix(in srgb, var(--erro) 8%, transparent)"
        : "var(--surface2)",
    }}>
      <p style={{ margin: 0, fontSize: 11.5, lineHeight: 1.55, color: "var(--txt2)" }}>
        <b className="num">{data.total}</b> veículos estão <b>sem categoria</b> — e categoria é o
        que liga o veículo ao contrato: sem ela, licença nenhuma abre o conteúdo.
        {data.comConteudo > 0 && (
          <>
            {" "}
            <b style={{ color: "var(--erro)" }}>
              <span className="num">{data.comConteudo}</span> deles já têm conteúdo publicado
            </b>
            : <span className="num">{data.linhas}</span> linhas de busca e{" "}
            <span className="num">{data.conteudos}</span> conteúdos que o cliente vê e não abre.
          </>
        )}
        {" "}
        <button
          onClick={() => setAberto((a) => !a)}
          style={{
            border: 0, background: "transparent", padding: 0, cursor: "pointer",
            fontSize: 11.5, color: "var(--brand-on-soft)", textDecoration: "underline",
          }}
        >
          {aberto ? "esconder" : "ver quais"}
        </button>
      </p>

      {aberto && (
        <div style={{
          marginTop: 8, maxHeight: 220, overflowY: "auto",
          border: "1px solid var(--line2)", borderRadius: 6, background: "var(--surface)",
        }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 11.5 }}>
            <tbody>
              {doem.map((v) => (
                <tr key={v.id} style={{ borderBottom: "1px solid var(--line2)" }}>
                  <td style={{ ...cel, width: 60 }} className="mono">{v.id}</td>
                  <td style={cel}>
                    <button
                      onClick={() => aoEscolher(v.id)}
                      style={{
                        border: 0, background: "transparent", padding: 0, cursor: "pointer",
                        fontSize: 11.5, color: "var(--brand-on-soft)", textAlign: "left",
                      }}
                    >
                      {v.marca} {v.modelo}
                    </button>
                  </td>
                  <td style={{ ...cel, width: 165, textAlign: "right", color: "var(--erro)" }}>
                    <span className="num">{v.linhas}</span> {v.linhas === 1 ? "linha" : "linhas"} ·{" "}
                    <span className="num">{v.conteudos}</span>{" "}
                    {v.conteudos === 1 ? "conteúdo" : "conteúdos"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {resto > 0 && (
            <p style={{ margin: 0, padding: "7px 9px", fontSize: 11, color: "var(--txt3)", lineHeight: 1.5 }}>
              Mais <b className="num">{resto}</b> sem categoria e <b>sem conteúdo publicado</b> —
              cadastro incompleto, mas ninguém esbarra neles hoje. Filtre a lista por marca para
              encontrá-los; a ficha mostra as categorias vazias.
            </p>
          )}
        </div>
      )}
    </div>
  )
}

const cel: React.CSSProperties = { padding: "4px 9px", verticalAlign: "top" }
